export default "__VITE_ASSET__tCuE6Sps__"